module.exports = __webpack_public_path__ + "img/tools_relocation_calculator1.5bc819c2.png";